var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2873_6450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6249 12C21.6247 11.4483 21.5745 10.8977 21.4749 10.355L24.5179 8.6L21.5179 3.4L18.4739 5.159C17.6335 4.43993 16.6677 3.88194 15.6249 3.513V0H9.62493V3.513C8.58219 3.88194 7.61639 4.43993 6.77593 5.159L3.73193 3.4L0.731934 8.6L3.77493 10.355C3.57504 11.4426 3.57504 12.5574 3.77493 13.645L0.731934 15.4L3.73193 20.6L6.77593 18.842C7.61647 19.5607 8.58226 20.1184 9.62493 20.487V24H15.6249V20.487C16.6677 20.1181 17.6335 19.5601 18.4739 18.841L21.5179 20.6L24.5179 15.4L21.4749 13.645C21.5745 13.1023 21.6247 12.5517 21.6249 12ZM15.6249 12C15.6249 12.5933 15.449 13.1734 15.1193 13.6667C14.7897 14.1601 14.3212 14.5446 13.773 14.7716C13.2248 14.9987 12.6216 15.0581 12.0397 14.9424C11.4577 14.8266 10.9232 14.5409 10.5036 14.1213C10.0841 13.7018 9.79833 13.1672 9.68258 12.5853C9.56682 12.0033 9.62623 11.4001 9.85329 10.8519C10.0804 10.3038 10.4649 9.83524 10.9582 9.50559C11.4516 9.17595 12.0316 9 12.6249 9C13.4206 9 14.1836 9.31607 14.7463 9.87868C15.3089 10.4413 15.6249 11.2044 15.6249 12Z",
    fill: "#212538"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2873_6450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsOff);
export default __webpack_public_path__ + "static/media/settingsOff.11efb1977e869d12bf9b0aade81ff9e1.svg";
export { ForwardRef as ReactComponent };